const Excel = 'excel';
const Irs = 'irs';
const Full = 'full';
const Excel3565 = 'excel3565';
const ApportionMethod = 'apportionMethod';
const Excel3575 = 'excel3575';
const Excel3560 = 'excel3560';
const Excel375625 = 'excel375625';
const Excel4060 = 'excel4060';
const Excel3070 = 'excel3070';

exports.ByName = {
  Excel: { Name: Excel, Id: 1 },
  Irs: { Name: Irs, Id: 2 },
  Full: { Name: Full, Id: 3 },
  Excel3565: { Name: Excel3565, Id: 4 },
  ApportionMethod: { Name: ApportionMethod, Id: 5 },
  Excel3575: { Name: Excel3575, Id: 6 },
  Excel3560: { Name: Excel3560, Id: 7 },
  Excel4060: { Name: Excel4060, Id: 8 },
  Excel3070: { Name: Excel3070, Id: 9 },
  Excel375625: { Name: Excel375625, Id: 10 }
};

exports.ById = {
  1: { Name: Excel, Id: 1 },
  2: { Name: Irs, Id: 2 },
  3: { Name: Full, Id: 3 },
  4: { Name: Excel3565, Id: 4 },
  5: { Name: ApportionMethod, Id: 5 },
  6: { Name: Excel3575, Id: 6 },
  7: { Name: Excel3560, Id: 7 },
  8: { Name: Excel4060, Id: 8 },
  9: { Name: Excel3070, Id: 9 },
  10: { Name: Excel375625, Id: 10 }
};
